import {url} from '../utils/url';
import axios from 'axios';
//retrive all assigned sales
export const allAssignedSales = () => {
    return axios.get(url + '/retrive_all_assigned_sales')
    .then(res => {
        return res.data;
    }).catch(err => console.log(err))
}